// extracted by mini-css-extract-plugin
export var baseButton = "_qp-0";
export var controlsArrowKeys = "_qp-1";
export var controlsResetButton = "_qp-2";
export var lightGameButton = "_qp-4 _qp-0";
export var playAgainButton = "_qp-5 _qp-0";
export var startGameButton = "_qp-3 _qp-0";